/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";
export const GET_BOXES = gql`
query GetAdptBoxes($filters: AdptBoxFilterInput, $options: GetManyOptions) {
  getAdptBoxes(filters: $filters, options: $options) {
    count
    limit
    skip
    content {
      costumeID
      id
      masqID
      deliveryStatus
      user {
        email
        firstName
        fullName
        id
        vuid
        lastName
      }
    }
    
  }
}
`;
